import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { SystemCommonModule } from '../system-common/system-common.module';
import { AgentApplicationStatusComponent } from './agent-application-status/agent-application-status.component';
import { AgentPerformanceStatusComponent } from './agent-performance-status/agent-performance-status.component';
import DateRangePicker from '@ui5/webcomponents/dist/DateRangePicker';
import { AgentProductionStatusComponent } from './agent-production-status/agent-production-status.component';
import { AgentPerformanceComponent } from './agent-performance/agent-performance.component';
import { TeamPerformanceComponent } from './team-performance/team-performance.component';
import { ContestAndIncentiveDetailsModule } from '../contest-and-incentive-details/contest-and-incentive-details.module';
import { DashboardBalanceComponent } from './dashboard-balance/dashboard-balance.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { HomeRoutingModule } from './home-routing.module';
import { TestRestApiComponent } from './test-rest-api/test-rest-api.component';
import { NotificationsTestApiStepFormComponent } from '../Notifications/notifications-test-api-step-form/notifications-test-api-step-form.component';
import { AgentTestApiStepFormComponent } from '../agent/agent-test-api-step-form/agent-test-api-step-form.component';
import { SearchesTestApiStepFormComponent } from '../searches-test-rest-api/searches-test-api-step-form/searches-test-api-step-form.component';
import { SalesMetricsDashboardComponent } from './sales-metrics-dashboard/sales-metrics-dashboard.component';
import { BusinessCommonService } from '../business-common/service/business-common.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DashboardModule } from '../dashboard/dashboard.module';
import { DashboardDataComponent } from './dashboard-data/dashboard-data.component';
import { EarningComponent } from './earning/earning.component';
import { PremiumOverDueComponent } from './premium-over-due/premium-over-due.component';
import { TraningsAndExamsComponent } from './tranings-and-exams/tranings-and-exams.component';
import { EonboardingLandingPageComponent } from './eonboarding-landing-page/eonboarding-landing-page.component';

// FullCalendarModule.registerPlugins([
//   // register FullCalendar plugins
//   dayGridPlugin,
//   interactionPlugin,
// ]);

function onAppInit(): () => Promise<any> {
  return (): Promise<any> => {
    DateRangePicker.define();
    return DateRangePicker.define();
  };
}

@NgModule({
  declarations: [
    AgentProductionStatusComponent,
    AgentPerformanceComponent,
    AgentApplicationStatusComponent,
    AgentPerformanceStatusComponent,
    DashboardDataComponent,
    PremiumOverDueComponent,
    TraningsAndExamsComponent,
    EarningComponent,
    TeamPerformanceComponent,
    DashboardBalanceComponent,
    TestRestApiComponent,
    LandingPageComponent,
    NotificationsTestApiStepFormComponent,
    AgentTestApiStepFormComponent,
    SearchesTestApiStepFormComponent,
    SalesMetricsDashboardComponent,
    EonboardingLandingPageComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    ContestAndIncentiveDetailsModule,
    SystemCommonModule,
    FormsModule,
    // BsDatepickerModule.forRoot(),
    // ChartsModule,
    //DragulaModule.forRoot(),
    BrowserModule,
    FullCalendarModule,
    DashboardModule,
    DragDropModule, // register FullCalendar with your app
  ],
  exports: [
    PremiumOverDueComponent,
    TraningsAndExamsComponent,
    DashboardDataComponent,
    EonboardingLandingPageComponent,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: onAppInit,
      multi: true,
    },
    BusinessCommonService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
